import clsx from "clsx";
import { ReactElement } from "react";

export const ErrorMessage = ({
  children,
  className,
  ...props
}: {
  children: React.ReactNode;
  className?: string;
} & React.HTMLAttributes<HTMLDivElement>): ReactElement => (
  <div
    data-slot="error"
    {...props}
    className={clsx(
      className,
      "text-base/6 text-red-600 data-[disabled]:opacity-50 sm:text-sm/6 dark:text-red-500",
    )}
  >
    {children}
  </div>
);
